
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFnsV2';
import { sv } from 'date-fns/locale';

interface IProps {}

const localizationProviderProps = {
  dateAdapter: AdapterDateFns,
  adapterLocale: sv,
  localeText: {
    previousMonth: 'Föregående månad',
    nextMonth: 'Nästa månad',
    cancelButtonLabel: 'Avbryt',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Dagens datum',
  },
};

const DatePickersLocalizationProvider: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  return (
    <LocalizationProvider {...localizationProviderProps}>
      {props.children}
    </LocalizationProvider>
  );
};

export default DatePickersLocalizationProvider;
